import {Heading} from "@/components/ui/heading";
import React, { useState, useEffect, useRef } from "react";
import {Link, useNavigate} from "react-router-dom";
import Paths from "../../constants/Paths";
import parse from 'html-react-parser';

const chartImages = {
    'ai-assistant': {
        movie: require('../../assets/movies/ai-assistant.mp4'),
        text: 'Take full control of the market with the AI Assistant! ' +
            'In just a few seconds, launch the AI Assistant, enable linear regression, and adjust your data. ' +
            'The system instantly tailors the analysis to your needs. ' +
            'Don’t waste time on manual analysis — AI does it for you, identifying the best entry and exit points. ' +
            'Activate the Assistant now and start investing like a pro!'
    },
    'technical-analysis': {
        movie: require('../../assets/movies/technical-analysis.mp4'),
        text: 'Stop wasting time searching through charts—one click gives you a full technical analysis, served on a platter! ' +
            'The system automatically filters out market noise, highlighting only the levels that truly matter. ' +
            'You instantly know what to watch and which market moves to respond to. ' +
            'Click, generate your analysis, review it, mark key levels, and invest with confidence!'
    },
    'notifications': {
        movie: require('../../assets/movies/notifications.mp4'),
        text: 'Never miss a key market moment again! ' +
            'As soon as the AI Assistant detects an opportunity, you’ll receive an instant notification, allowing you to react without delay. ' +
            'Make fast decisions and seize opportunities before others do. ' +
            'Turn on notifications and stay ahead of the market at all times!'
    },
}

const SectionChart = () => {
    const navigate = useNavigate();
    const [imageType, setImageType] = useState("ai-assistant");
    const videoRef = useRef(null);

    const handleChangeImage = (type) => {
        setImageType(type);
    }

    useEffect(() => {
        if (videoRef.current) {
            videoRef.current.load();
            videoRef.current.play();
        }
    }, [imageType]);

    return (
        <section id="chart-section" className="py-14 dark-bg-with-gradients">
            <div className='generic-container'>
                <Heading level={2}>
                    Locked Trade is more than just a platform<span className="break-line">&nbsp;</span>
                    – it’s a comprehensive solution<span className="break-line">&nbsp;</span>
                    designed for individuals who strive for more.<span className="break-line">&nbsp;</span>
                    Our tools combine modern technologies, ease of use,<span className="break-line">&nbsp;</span>
                    and accessibility from anywhere in the world.
                </Heading>
                <p className='text-white pt-8 text-center font-bold'>
                    Locked Trade offers a unique blend of technology and support, enabling both beginner and experienced
                    traders to achieve success.
                </p>
                <p className='text-white pt-4 text-center'>
                    With our innovative approach, you gain access to precise analyses, AI-powered tools, and a community
                    that shares your passion for investing.<span className="break-line">&nbsp;</span>
                    No matter where you are or what device you use, our platform provides everything you need – from
                    education and market signals to advanced real-time analysis.<span
                    className="break-line">&nbsp;</span>
                    With Locked Trade, every investment decision becomes more thoughtful and effective.
                    Join us and discover how simplicity and sophistication can work in harmony to your advantage.
                </p>

                <div className="flex items-center justify-center mt-10">
                    <div className="flex items-center flex-wrap justify-center gap-1 rounded-full">
                        <button
                            className={`px-4 py-2 rounded-full transition-all text-white chart-button uppercase font-medium ${imageType === "ai-assistant" ? 'bg-lt-blue' : 'bg-lt-dark-blue'} `}
                            onClick={() => handleChangeImage("ai-assistant")}
                        >
                            AI Assistant
                        </button>
                        <button
                            className={`px-4 py-2 rounded-full transition-all text-white chart-button uppercase font-medium ${imageType === "technical-analysis" ? 'bg-lt-blue' : 'bg-lt-dark-blue'} `}
                            onClick={() => handleChangeImage("technical-analysis")}
                        >
                            Technical analysis
                        </button>
                        <button
                            className={`px-4 py-2 rounded-full transition-all text-white chart-button uppercase font-medium ${imageType === "notifications" ? 'bg-lt-blue' : 'bg-lt-dark-blue'} `}
                            onClick={() => handleChangeImage("notifications")}
                        >
                            Notifications
                        </button>
                    </div>
                </div>

                <div className="chart-section--video-container">
                    <video ref={videoRef} className="background-video" data-mode="center" data-keepplaying="1"
                           preload="auto"
                           webkit-playsinline="webkit-playsinline" playsInline muted>
                        <source src={chartImages[imageType].movie} type="video/mp4"/>
                        Your browser does not support the video tag.
                    </video>
                </div>

                <p className='text-white pt-8 text-center text-sm'>
                    {parse(chartImages[imageType].text)}
                </p>

                <div className={`text-center`}>
                    <Link to={Paths.VIRTUAL_ASSISTANT} className="big-button white-variant mx-auto mt-14">CHECK HOW IT
                        WORKS?</Link>
                </div>
            </div>
        </section>
    )
}

export default SectionChart;